export default __webpack_public_path__ + "static/media/IMG_5127.e1d91c64.JPG";